import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h2>Enjoy coffee. Together.</h2>
    <Link to="/page-2/">Grab a brew at...</Link>
  </Layout>
)

export default IndexPage
